import React, { useContext, useEffect } from "react";
import "./Header.css";
import { FaEnvelope } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetNotificationCount } from "../../features/notification/Slice";
import { Context } from "../../utils/context";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { signin } = useContext(Context)

  const notifications = useSelector((state) => state.notification.count);


  useEffect(() => {
    if (signin) {
      dispatch(GetNotificationCount())
    }
  }, [dispatch, signin])

  return (
    <section className="Header">
      <div className="header_container">
        <div className="header-left">
          <h2 className="logo_img_holder">
            <Link to="/home">
              <img
                src="/assets/images/logo/brown_money_king.png"
                alt="logo img"
                className="logo_img"
              />
            </Link>
          </h2>
        </div>

        <div className="header-right">
          <div
            className="notification-icon"
            onClick={() => navigate("/notifications")}
          >
            <FaEnvelope />
            {notifications?.unread > 0 &&
              <span className="notification-dot"></span>
            }
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
